<template>
    <b-modal
        id="create-internship-modal"
        modal-class="apprentice-default-modal internship-create"
        :title="$t('internship.add_internship')"
        size="lg"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        @ok="storeInternship"
        @show="onShow">
        <div class="internship-create-form">
            <div
                class="internship-banner-preview"
                v-if="banner_preview !== ''">
                <b-img :src="banner_preview"></b-img>
            </div>

            <b-alert
                v-if="errorsFound"
                variant="danger"
                show>
                {{ $t('internship.you_did_not_fill_in_all_fields_correctly') }}
            </b-alert>

            <b-alert
                v-if="contactErrors"
                variant="warning"
                show>
                {{ $t('internship.you_must_fill_in_at_least_a_mail_address_or_a_phone_number') }}
            </b-alert>

            <b-form-group
                class="internship-name"
                label-for="internship-name-input"
                :label="$t('common.name')">
                <!--Required-->
                <template #label> {{ $t('common.name') }} <span class="required">*</span></template>
                <b-form-input
                    id="internship-name-input"
                    v-model="name"
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="group-input-file"
                :label="$t('internship.image')"
                label-for="internship-banner-input">
                <template #label>
                    {{ $t('internship.image') }}
                </template>
                <b-form-file
                    class="apprentice-file-upload internship-banner-upload"
                    id="internship-banner-input"
                    v-model="file"
                    accept="image/jpeg,image/png"
                    :placeholder="$t('internship.upload_banner')"
                    @change="showPreview"></b-form-file>
            </b-form-group>

            <div class="internship-type-and-duration">
                <b-form-group
                    class="internship-duration-tags"
                    label-for="internship-duration-tags-input"
                    :label="$t('internship.internship_duration')">
                    <!-- required-->
                    <template #label>
                        {{ $t('internship.internship_duration') }} <span class="required">*</span>
                    </template>

                    <design-2021-apprentice-multiselect-component
                        v-model="durationTags"
                        label="name"
                        :options="internshipDurationTagsIn"
                        track-by="id">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>

                <b-form-group
                    class="internship-tags"
                    label-for="internship-tags-input"
                    :label="$t('internship.internship_type')">
                    <design-2021-apprentice-multiselect-component
                        v-model="tags"
                        label="name"
                        :options="internshipTagsIn"
                        track-by="id">
                    </design-2021-apprentice-multiselect-component>
                    <!--Niet required-->
                </b-form-group>
            </div>

            <div class="internship-organization-seats">
                <b-form-group
                    class="internship-spots"
                    label-for="internship-placements-input"
                    :label="$t('internship.amount_of_places')">
                    <b-form-input
                        id="internship-placements-input"
                        v-model="placements"
                        :placeholder="$t('internship.amount_of_places')"
                        type="number"
                        min="0"
                        max="200">
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    class="internship-organization"
                    label-for="internship-organization-input"
                    :label="$t('common.organization')">
                    <!--Required-->
                    <template #label> {{ $t('common.organization') }} <span class="required">*</span></template>
                    <b-form-input
                        id="internship-name-input"
                        v-model="organization"
                        :placeholder="$authUser.school.name">
                    </b-form-input>
                </b-form-group>
            </div>

            <b-form-group
                class="personal-internship-organization"
                label-for="personal-internship-organization-input"
                :label="$t('internship.name_supervisor')">
                <template #label> Naam stagebegeleider:</template>
                <b-form-input
                    id="personal-internship-organization-input"
                    v-model="supervisor"
                    :placeholder="$t('internship.name_supervisor')">
                </b-form-input>
            </b-form-group>

            <design-2021-apprentice-address-form-component
                @contactData="updateContactData($event)"
                ref="contact-info">
                <!--Required-->
            </design-2021-apprentice-address-form-component>

            <b-form-group
                class="internship-description"
                label-for="internship-description-input"
                :label="$t('common.description')">
                <!--Required-->
                <template #label>
                    {{ $t('common.description') }}
                </template>
                <ckeditor
                    v-model="description"
                    :editor="editor"
                    :config="editorConfig">
                </ckeditor>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';
import { ords } from '../../../app';
import $ from 'jquery';

export default {
    name: 'design-2021-internships-create-modal-component',
    props: {
        internshipTagsIn: {
            type: Array,
            required: true,
        },
        internshipDurationTagsIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            organization: this.$authUser.school.name,
            name: '',
            description: '',
            contactData: {},
            // slots: '',
            tags: [],
            durationTags: [],
            file: null,
            placements: null,
            banner_preview: '',
            editor: ApprenticeEditor,
            supervisor: null,
            editorConfig: {
                placeholder: this.$t('common.description'),
                contentsCss: 'internship-description',
                bodyClass: 'internship-description-body',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {
                    uploadUrl: this.routes.baseUrl() + '/image/upload',
                },
            },
            errorsFound: false,
            contactErrors: false,
        };
    },
    methods: {
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
        storeInternship(bvModalEvent) {
            if (this.hasErrors()) {
                this.errorsFound = true;
                bvModalEvent.preventDefault();
                $('.internship-create').animate({ scrollTop: 0 }, 500);
                return;
            }
            this.alert.saving();
            const durationTagIds = this.durationTags.map((tag) => tag.id);
            const tagIds = this.tags.map((tag) => tag.id);
            const formData = new FormData();
            formData.append('organization', this.organization);
            formData.append('supervisor', this.supervisor);
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('placements', this.placements === null ? 1 : this.placements);
            formData.append('contactData', JSON.stringify(this.contactData));
            for (let i = 0; i < tagIds.length; i++) {
                formData.append('tags[' + i + ']', tagIds[i]);
            }
            for (let i = 0; i < durationTagIds.length; i++) {
                formData.append('durationTags[' + i + ']', durationTagIds[i]);
            }
            if (this.file) {
                formData.append('file', this.file);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.internship(), formData, { headers: headers })
                .then((response) => {
                    ords.use('internship').add(response.data);
                    this.alert.success();
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },

        onShow() {
            this.name = '';
            this.description = '';
            this.contactData = {};
            this.tags = [];
            this.durationTags = [];
            this.placements = null;
            this.file = null;
            this.banner_preview = '';
            this.errorsFound = false;
            this.contactErrors = false;
        },

        hasErrors() {
            this.errorsFound = false;
            this.contactErrors = false;

            if (this.name === '') {
                this.errorsFound = true;
            }

            if (this.contactData.city === undefined || this.contactData.city === '') {
                this.errorsFound = true;
            }

            if (this.contactData.street === undefined || this.contactData.street === '') {
                this.errorsFound = true;
            }

            if (this.contactData.streetNumber === undefined || this.contactData.streetNumber === '') {
                this.errorsFound = true;
            }

            if (this.contactData.zipcode === undefined || this.contactData.zipcode === '') {
                this.errorsFound = true;
            }

            if (this.contactData.email !== undefined && this.contactData.email !== '') {
                if (!this.$options.filters.validate_email(this.contactData.email)) {
                    this.errorsFound = true;
                }
            }

            if (
                (this.contactData.email === undefined || this.contactData.email === '') &&
                (this.contactData.phone === undefined || this.contactData.phone === '')
            ) {
                this.contactErrors = true;
                this.errorsFound = true;
            }

            if (this.durationTags.length === 0) {
                this.errorsFound = true;
            }

            return this.errorsFound;
        },

        updateContactData(contactData) {
            this.contactData = contactData;
        },
    },
};
</script>

<style scoped lang="scss">
input.form-control,
select,
textarea {
    margin-bottom: 0;
}

::v-deep div.form-group {
    flex: 1 0 auto;
}

.internship-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}

.internship-company-location-type-group ::v-deep {
    display: flex;
    flex-direction: column;

    .form-group {
        flex: 1;
    }

    .input-group-prepend {
        flex: 1;

        .multiselect__tags {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    .btn-add-organizations {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
        padding-left: map-get($grid-gutter-spacing, 'fifteen');
        padding-right: map-get($grid-gutter-spacing, 'fifteen');

        &:before {
            margin-right: 0;
        }
    }
}

.internship-banner-upload ::v-deep {
    height: 51px;

    label {
        margin-bottom: 0;
    }

    .form-file-text {
        color: $text-muted-color;
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .internship-company-location-type-group ::v-deep {
        column-gap: $grid-gutter-width;
        flex-direction: row;
        justify-content: space-between;

        .internship-location,
        .internship-tags,
        .internship-organization {
            flex: 1 0 auto;
            max-width: calc(33% - 15px);
        }
    }

    .internship-type-and-duration,
    .internship-organization-seats {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: $grid-gutter-width;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .form-group {
            margin-bottom: 0;
        }
    }

    .internship-type-and-duration {
        .form-group {
            flex: 0 1 calc(50% - 15px);
        }
    }

    .internship-organization-seats {
        .internship-spots {
            flex: 0 1 calc(25% - 15px);
        }

        .internship-organization {
            flex: 0 1 calc(75% - 15px);
        }
    }
}
</style>
